import { ReactNode } from 'react';

import { useIsMobile } from '@/shared/hooks/use-mobile';

import { AppBreadcrumbs } from './app-breadcrumbs';
import { BaseHeader } from './base-header';
import { SidebarLayout } from './sidebar-layout';
import { UserSettingsDropdown } from './user-settings-dropdown';

export const AuthLayout = ({ children }: { children: ReactNode }) => {
  const isMobile = useIsMobile();

  return (
    <SidebarLayout>
      <BaseHeader>{!isMobile && <UserSettingsDropdown />}</BaseHeader>

      <div className="bg-white px-4 md:px-10">
        <AppBreadcrumbs />
      </div>

      <div className="min-h-[100vh]">{children}</div>
    </SidebarLayout>
  );
};
